export default (env = process.env) => ({
  stripeKey: "pk_live_ra8zkP1zTqXhEOfcApEIONPU",
});
